import RPMReportDailyCarePlan from './report-daily-care-plan';
import './report-daily-care-plan.css';

export default RPMReportDailyCarePlan;
